import { render, staticRenderFns } from "./CertificateQuery.vue?vue&type=template&id=be0790d2"
import script from "./CertificateQuery.vue?vue&type=script&lang=js"
export * from "./CertificateQuery.vue?vue&type=script&lang=js"
import style0 from "./CertificateQuery.vue?vue&type=style&index=0&id=be0790d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports